module.exports = __webpack_public_path__ + "static/media/tlyfeLogo1.e6e9adee.png";